import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // hasProcessed guards against double-processing (e.g., StrictMode remounts
    // or dependency-triggered re-runs) — the session_id is single-use.
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.hash.slice(1));
    const sessionId = params.get("session_id");
    window.history.replaceState(null, "", window.location.pathname);

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(res.data);
        navigate("/portal", { replace: true, state: { user: res.data } });
      } catch (err) {
        console.error("Session exchange failed", err);
        const restricted = err?.response?.status === 403;
        navigate(`/login?error=${restricted ? "restricted" : "failed"}`, { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback-loading">
      <Loader2 size={28} className="animate-spin bronze" />
    </div>
  );
}
